import EditText from './EditText';

export default EditText;
